import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import axios from "axios";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import TextareaAutosize from "@mui/base/TextareaAutosize";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined"
import InfoIcon from '@mui/icons-material/Info';
import Button from "@mui/material/Button";
import "./userIssues.scss";
import { useEffect, useState } from "react";
import { errorToast, successToast } from "../../common/ToastMessage";
import moment from "moment";
import Loader from "../../common/Loader";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Unstable_Grid2';
import { Typography } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { isVisible } from "@testing-library/user-event/dist/utils";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

function User() {
  const [show, setShow] = useState(false)
  const locale = 'en';
  const today = new Date();
  const day = today.toLocaleDateString(locale, { weekday: 'long' });
  const date = `${day}, ${today.getDate()} ${today.toLocaleDateString(locale, { month: 'long' })}\n\n`;
  const time = today.toLocaleTimeString(locale, { hour: 'numeric', hour12: true, minute: 'numeric' });
  const [resolveDate, setTimeLeft] = useState();
  const [showDiv, setShowDiv] = useState(false);
  // const [showresolve,setShowResolve] = useState(false);
  const [error, setError] = React.useState([]);
  const [selectdevice, setSelectDevice] = React.useState([]);
  const [selectbox, setSelectBox] = React.useState();
  const [appliance, setAppliance] = useState([]);
  const [management, setManagement] = useState([]);
  const [accept, setAccept] = useState("");
  const [reject, setReject] = useState("");
  const [selectedDevices, setSelectDevices] = useState([]);
  const [showdevice, setShowDevice] = useState();
  const [adminResponse, setAdminResponse] = useState("");
  const [isActive, setLoaderActive] = useState(false);
  const [isvisible, setVisible] = useState(null);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const employeeName = userData?.[0]?.employeeName;
  const managementId = userData?.[0]?.managementId;
  const headers = {
    Authorization: "Bearer " + localStorage.getItem("_token"),
    "Content-type": "application/json",
  };

  useEffect(() => {
    getmanagementid();
    getappliance();
    issuestatus();
  }, [])

  useEffect(() => {
    const data = []
    // monitor
    appliance?.moniter?.map((item) => {
      if (item?.applianceId == management?.monitorId) {
        data.push(item)
      }
      setSelectDevices(data);
    })
    // camera
    appliance?.camera?.map((item) => {
      if (item?.applianceId == management?.cameraId) {
        data.push(item)
      }
      setSelectDevices(data);
    })
    //  cpu
    appliance?.cpu?.map((item) => {
      if (item?.applianceId == management?.cpuId) {
        data.push(item)
      }
      setSelectDevices(data);
    })
    //keyboard
    appliance?.keyboard?.map((item) => {
      if (item?.applianceId == management?.keybordId) {
        data.push(item)
      }
      setSelectDevices(data);
    })
    //mouse
    appliance?.mouse?.map((item) => {
      if (item?.applianceId == management?.mouseId) {
        data.push(item)
      }
      setSelectDevices(data);
    })
    //headphone
    appliance?.headphone?.map((item) => {
      if (item?.applianceId == management?.headphoneId) {
        data.push(item)
      }
      setSelectDevices(data);
    })
  }, [management, appliance])

  const getappliance = async (id) => {
    axios.get(
      `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Management/GetAllAppliances`,
      {
        headers: headers,

      }
    ).then((response) => {
      setAppliance(response?.data?.data)
    }).catch(function (error) {
      console.log("error", error);
      if (error?.response?.status === 401) {
        errorToast(error?.response?.statusText)
      } else {
        errorToast(error?.message)
      }
    });
  };

  const getmanagementid = async (id) => {
    axios.get(
      `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Management/EmployeeGetById`,
      {
        headers: headers,
        params: {
          id: managementId,
        },
      }
    ).then((response) => {
      setManagement(response?.data?.data);

    }).catch(function (error) {
      console.log("error", error);
      if (error?.response?.status === 401) {
        errorToast(error?.response?.statusText)
      } else {
        errorToast(error?.message)
      }
    });
  };

  const issuestatus = async (id) => {
    setLoaderActive(true)
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
      "Content-type": "application/json",
    };
    axios.get(
      `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Issue/IssueStatus?id=${managementId}`,
      {
        headers: headers,
      }
    ).then((response) => {
      setLoaderActive(false);
      setShowDevice(response.data.data)
    })
      .catch(function (error) {
        console.log("error", error);
        setLoaderActive(false);
        if (error?.response?.status === 401) {
          errorToast(error?.response?.statusText)
        } else {
          errorToast(error?.message)
        }
      });
  };

  const getresolvedissue = async (issueId) => {
    setLoaderActive(true);
    try {
      axios.post(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Issue/UpdateYesIssues?id=${issueId}`,
        {},
        {
          headers: headers,
        }
      ).then((response) => {
        if (response.status === 200) {
          successToast(response?.data?.message)
          issuestatus();
          setLoaderActive(false);
        }
      });
    } catch (error) {
      console.log(error);
      setLoaderActive(false);
      if (error?.response?.status === 401) {
        errorToast(error?.response?.statusText)
      } else {
        errorToast(error?.message)
      }
    }
  };

  const getpendingissue = async (issueId) => {
    setLoaderActive(true);
    try {
      axios.post(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Issue/UpdateNoIssues?id=${issueId}`,
        {},
        {
          headers: headers,
        }
      ).then((response) => {
        if (response.status === 200) {
          successToast(response?.data?.message)
          issuestatus();
          setLoaderActive(false);
        }
      });
    } catch (error) {
      console.log(error);
      setLoaderActive(false);
      if (error?.response?.status === 401) {
        errorToast(error?.response?.statusText)
      } else {
        errorToast(error?.message)
      }
    }
  };

  const handleChange = (event) => {
    setSelectDevice(event.target.value)
  };

  const validate = () => {
    setError([]);
    let error = {};
    if (selectdevice?.length == 0) {
      error.selectdevice = "Please select device";
    }
    if (!selectbox) {
      error.selectbox = "Please enter the Issue Description";
    }
    if (Object.keys(error).length > 0) {
      setError(error);
      return false;
    }
    return true;
  };

  //resolve time 
  useEffect(() => {
    const interval = setInterval(() => {
      if (resolveDate > 0) {
        setTimeLeft(resolveDate - 1);
        // setShowResolve(true);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [resolveDate]);


  useEffect(() => {
    if (resolveDate > 0) {
      setShowDiv(false);
    } else {
      setShowDiv(true);
    }
  }, [resolveDate]);


  const handleDelete = (e, value) => {
    e.preventDefault();
    setSelectDevice(selectdevice.filter((applianceCode) => applianceCode !== value));
  };

  // const handleVisible = (e,id) => {
  //   // console.log("id", issueId)

  //       setVisible(!isvisible)

  // }
  const handleVisible = (id) => {
    if (id === isvisible) {
      setVisible(null);
    } else {
      setVisible(id);
    }
  }

  const SendUser = () => {
    if (validate()) {
      const result = selectedDevices.filter(c => selectdevice.some(s => s === c.applianceCode))?.map((item) => { return item?.applianceId });
      let payload = {
        "ManagementID": managementId,
        "Appliances": result,
        "Date": moment(),
        "IssueDescription": selectbox,
      }
      axios
        .post(`${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Issue`, payload, {
          headers: headers,
        })
        .then(function (response) {
          if (response?.status == "200") {
            successToast(response?.data?.message)
            setShow(true);
            setSelectBox('')
            setSelectDevice([])
            setError([])
            issuestatus()
          }
        })
        .catch(function (error) {
          console.log("error", error);
          if (error?.response?.status === 401) {
            errorToast(error?.response?.statusText)
          } else {
            errorToast(error?.message)
          }
        });
    }
  }

  const showResolvedBtns = (issueData) => {
    if (issueData?.resolveDate !== null) {
      const date = new Date(issueData?.resolveDate);
      var now = moment(date);
      var then = moment();
      var ms = moment(now).diff(moment(then));
      var d = moment.duration(ms);
      const diff = d?._data
      // console.log("d---", d?._data);
      console.log("issueData issueDescription---", issueData?.issueDescription);
      console.log("issueData---", issueData?.resolveDate, moment(new Date(issueData?.resolveDate)).format('dddd, MMMM D, YYYY h:mm A'));
      return diff?.days <= 0 && diff?.months <= 0 && diff?.hours <= 0 && diff?.minutes <= 0
    }
  }

  const showDate = (createdDate) => {
    const newDate = new Date(createdDate)
    newDate.setHours(newDate.getHours() + 5);
    newDate.setMinutes(newDate.getMinutes() + 30);
    return moment(newDate).format('dddd, MMMM D YYYY h:mm A')
  }
  return (
    <>
      <Loader isLoading={isActive} />
      <div className="management">
        <div className="main-wrapper">
          <main className="main-sec active">
            <Container fluid className="custom-padding">
              <div className="user-issue-wrapper">
                <Row>
                  <Col xxl={5} xl={5} lg={5} md={12} sm={12}>
                    <h3 className="your-issue">Write your issue</h3>
                    <div className="user-form">
                      <Row>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                          <div className="txtfield-wrap">
                            <TextField
                              fullWidth
                              id="outlined-basic"
                              label="Employee name"
                              variant="outlined"
                              value={employeeName}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                          <div className="txtfield-wrap">
                            <FormControl fullWidth>
                              <InputLabel id="demo-multiple-chip-label">
                                Select Device
                              </InputLabel>
                              <Select
                                labelId="demo-multiple-chip-label"
                                required
                                id="demo-multiple-chip"
                                multiple
                                value={selectdevice}
                                error={error && error.selectdevice}
                                onChange={(event) => { setError([]); handleChange(event) }}
                                input={
                                  <OutlinedInput
                                    id="select-multiple-chip"
                                    label="Chip-multiple"
                                  />
                                }
                                renderValue={(selected) => (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: 0.5,
                                    }}
                                  >
                                    {selected.map((value) => (
                                      <Chip key={value} label={value} clickable deleteIcon={
                                        <CancelIcon
                                          onMouseDown={(event) => event?.stopPropagation()}
                                        />
                                      }
                                        onDelete={(e) => handleDelete(e, value)}

                                      />
                                    ))}
                                  </Box>
                                )}
                                MenuProps={MenuProps}
                              >
                                {selectedDevices && selectedDevices
                                  .map((item, idx) => {
                                    return (
                                      <MenuItem value={item?.applianceCode} key={`device-${idx + 1}`}>
                                        {item?.applianceCode} - {item?.brandName}
                                      </MenuItem>
                                    );
                                  })}

                              </Select>
                            </FormControl>
                            {error && error.selectdevice ? <span className="text-danger">{error.selectdevice}</span> : null}
                          </div>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                          <div className="txtfield-wrap">
                            <TextareaAutosize
                              aria-label="empty textarea"
                              placeholder=" please enter issue description..."
                              minRows={5}
                              style={{ width: "100%", borderRadius: '2px', ...error && error.selectbox ? { border: '1px solid red' } : {} }}
                              onChange={(e) => { setSelectBox(e.target.value); }}
                              required={true}
                              error={error && error.selectbox}
                              value={selectbox}
                            />
                            {error && error.selectbox ? <span className="text-danger">{error.selectbox}</span> : null}
                          </div>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                          <div className="your-issue-block text-end">
                            <Button variant="outlined" onClick={() => { setError([]); SendUser() }}>Send</Button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>

                  <Col xxl={7} xl={7} lg={7} md={12} sm={12}>
                    {showdevice?.length > 0 && (
                      <div className="communication-wrap">
                        <div>
                          {showdevice &&
                            showdevice.map((item, index) => {
                              return (
                                <>
                                  <div className="box-wrap" style={{ marginBottom: '10px' }}>
                                    {/* <Container> */}
                                    <Box>
                                      <Box container spacing={2} columns={10} padding={'15px'}  >
                                        {/* {console.log("new",moment(new Date(item?.date)).format('dddd, MMMM D YYYY h:mm a'))} */}
                                        <Typography>{showDate(item?.date)}</Typography>
                                        <br></br>
                                        <Grid container spacing={2} columns={10} padding={'15px'}  >
                                          <Grid xs={20}>
                                            <Item style={{ display: "flex", justifyContent: "space-between" }} >
                                              <b> Issue - {showdevice?.length - index}</b>
                                              {isvisible === item.issueId ? (
                                                <VisibilityIcon
                                                  onClick={() => handleVisible(item?.issueId)}
                                                  style={{ cursor: "pointer" }}
                                                />
                                              ) : (
                                                <VisibilityOffIcon
                                                  onClick={() => handleVisible(item?.issueId)}
                                                  style={{ cursor: "pointer" }}
                                                />
                                              )}
                                              {/* <VisibilityIcon style={{ cursor: "pointer" }} /> */}

                                            </Item>
                                          </Grid>
                                        </Grid>
                                      </Box>

                                      {isvisible === item.issueId && (

                                        <div style={{ margin: '20px' }}>


                                          <Grid container spacing={2} columns={10} padding={'15px'}  >
                                            {/* <Item style={{ padding: '8px', marginTop: '-30px' }} value={item?.managementId} key={`test-${index + 1}`}>
                                              <b>{item?.applianceCode.join(", ")}</b>
                                            </Item> */}

                                            {Array.from(item?.applianceCode).map((i, index) => (
                                              <Grid key={index} style={{ marginTop: '-37px' }} >
                                                <Box style={{ padding: '7px', backgroundColor: "#636161", color: 'white' }}>{i}</Box>

                                              </Grid>
                                            ))}

                                          </Grid>

                                          <Grid container spacing={2} columns={10} padding={'10px'}>
                                            <Grid xs={20}>
                                              <Item className="item-text" value={item?.issueDescription} key={`test-${index + 1}`}><b>
                                                Issue Description : {item?.issueDescription}</b>
                                              </Item>
                                            </Grid>
                                          </Grid>
                                          {item?.action == "Accept" ? (
                                            <>
                                              <Box className="box-sx">
                                                <div>
                                                  <div style={{ padding: '5px', margin: '-11px', backgroundColor: 'green' }}>
                                                    <CheckCircleIcon style={{ color: 'white' }} />
                                                    <span style={{ color: 'white' }}> Your Issue Accepted.</span>
                                                  </div>
                                                </div>
                                                <div style={{ padding: '5px', marginTop: '23px' }}>
                                                  <span value={item?.adminResponse} key={`test-${index + 1}`}>{item?.adminResponse}</span>
                                                </div>
                                                <div style={{ padding: '5px', marginTop: '4px' }}>
                                                  <span> Your concern has been acknowledged on {moment(new Date(item?.resolveDate)).format('dddd, MMMM D YYYY ')} and will be resolved until {moment(new Date(item?.resolveDate)).format('h:mm A')}.</span>
                                                </div>
                                              </Box>
                                              <div>
                                                <div>
                                                  <div style={{ padding: '5px', margin: '5px' }}>
                                                    {showResolvedBtns(item) && item?.resolveDate !== null ? (
                                                      <div style={{ padding: '7px', margin: '7px' }}>
                                                        <h5>Is Your Issue resolved?
                                                        </h5>
                                                        <div>
                                                          <Button style={{
                                                            borderRadius: '30px', lineHeight: '13px', padding: '10px 40px',
                                                            fontSize: '16px'
                                                          }} variant="contained" color="success" onClick={() => { getresolvedissue(item?.issueId) }}>Yes</Button>
                                                          <Button style={{
                                                            borderRadius: '30px', lineHeight: '13px', padding: '10px 40px',
                                                            margin: '7px', fontSize: '16px'
                                                          }} variant="contained" color="error" onClick={() => { getpendingissue(item?.issueId) }} >No</Button>
                                                        </div>
                                                      </div>
                                                    ) : null}
                                                  </div>
                                                </div>
                                              </div>
                                            </>

                                          ) : item?.action == "Pending" ? (
                                            <Box className="box-sx" >
                                              <div>
                                                <div style={{ padding: '5px', margin: '-11px', backgroundColor: 'orange' }}>
                                                  <InfoIcon style={{ color: 'white' }} />
                                                  {" "}
                                                  <span style={{ color: 'white' }}>Your issue is still pending.</span>
                                                </div>
                                                <div style={{ padding: '5px', marginTop: '25px' }}>
                                                  We have received your concern and will respond to you shortly.
                                                </div>
                                              </div>
                                              <div style={{ padding: '5px', margin: '4px' }}>
                                                <span value={item?.adminResponse} key={`test-${index + 1}`}>{item?.adminResponse}</span>
                                              </div>
                                              <br></br>
                                            </Box>

                                          ) : item?.action == "Reject" ? (
                                            <Box className="box-sx" >
                                              <div>
                                                <div style={{ padding: '5px', margin: '-11px', backgroundColor: 'red' }}>
                                                  <CancelIcon style={{ color: 'white' }} />
                                                  <span style={{ color: 'white' }}> Your Issue Rejected.</span>
                                                </div>
                                                <div style={{ padding: '5px', marginTop: '23px' }}>
                                                  <span >Your issue is rejected by Admin. kindly, contact to
                                                    management for user info.</span>
                                                </div>
                                                <span value={item?.adminResponse} key={`test-${index + 1}`}>{item?.adminResponse}</span>
                                              </div>
                                            </Box>) : null}
                                          <br></br>
                                        </div>
                                      )}
                                    </Box>
                                    {/* </Container> */}
                                  </div>
                                </>
                              );
                            })}
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            </Container>
          </main>
        </div>
      </div>
    </>
  );
}

export default User;
